import { FetchResultType } from '../../../../types/common/fetch-result';
import { HttpStatusCode } from './types/enum/http-status-code';

export const mapFetchResult = <
  SuccessRawBody extends object,
  SuccessMappedBody,
  ErrorRawBody extends object,
  ErrorMappedBody
>(
  result: FetchResultType<SuccessRawBody, ErrorRawBody>,
  fnSuccess: (body: SuccessRawBody) => SuccessMappedBody,
  fnError: (body: ErrorRawBody, status?: HttpStatusCode) => ErrorMappedBody
): FetchResultType<SuccessMappedBody, ErrorMappedBody> => {
  const { type, body, statusCode, headers } = result;
  switch (type) {
    case 'success':
      return {
        type,
        statusCode,
        body: fnSuccess(body as SuccessRawBody),
        headers
      };
    case 'error':
      return {
        type,
        statusCode,
        body: fnError(body as ErrorRawBody, statusCode),
        headers
      };
  }
};
